<template>
    <div>
        <h2>Anketa</h2>
        <p>Izberite iz seznama:</p>
        <ul>
            <li><a href="https://anketa-8df61.web.app/anketa/prvošolci">Prvošolci</a></li>
            <li><a href="https://anketa-8df61.web.app/anketa/drugošolci">Drugošolci</a></li>
            <li><a href="https://anketa-8df61.web.app/anketa/tretješolci">Tretješolci</a></li>
            <li><a href="https://anketa-8df61.web.app/anketa/četrtošolci">četrtošolci</a></li>
        </ul>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="less" scoped>
ul { list-style: none; }
a {
    display: block;
}
</style>